import { IRateCard } from "@wingspanhq/payments/dist/interfaces";
import { IRateCardUpdateRequest } from "@wingspanhq/payments/dist/interfaces/api";
import { servicePayments } from "../servicePayments";

export interface RateCardUpdateOptions {
  update: IRateCardUpdateRequest;
  keysToDelete?: string[];
}

export const updateRateCard = async (
  rateCardId: string,
  options: RateCardUpdateOptions
): Promise<IRateCard> => {
  const { update, keysToDelete } = options;

  // Build the final values object
  // The update.values contains only the overrides we want to keep
  // keysToDelete contains keys that should be removed (set to null for backend to delete)
  let finalValues = { ...update.values };

  // Set keys to delete as null so backend removes them
  if (keysToDelete?.length) {
    keysToDelete.forEach(key => {
      (finalValues as any)[key] = null;
    });
  }

  const payload = { values: finalValues };

  const response = await servicePayments.patch(
    `/rate-card/${rateCardId}`,
    payload
  );
  return response.data;
};
